import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { AuthorMessage } from './components/AuthorMessage';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="23u9ueosaffxt">
      <MetaPixel data-id="element-1" data-mp="3iiwfgpji5k3r" />
      <Hero data-id="element-2" data-mp="3ijfvg0pldyf5" />
      <main data-id="element-3" data-mp="3ihv1odb3qjic">
        <ProblemSection data-id="element-4" data-mp="3ii4r9zs8ioni" />
        <BeforeAfter data-id="element-5" data-mp="3ml1419v3fqjj" />
        <PainPoints data-id="element-6" data-mp="3mkho1yp07c85" />
        <Volumes data-id="element-7" data-mp="3mjzpgvevclx2" />
        <Toolkit data-id="element-8" data-mp="3mjgclt42snpw" />
        <Bonuses data-id="element-9" data-mp="3rc9i4j7dc031" />
        <Offer data-id="element-10" data-mp="3rbrcwx2qabiz" />
        <Guarantee data-id="element-11" data-mp="3rdarmj8qkein" />
        <Testimonials data-id="element-12" data-mp="3rcsuzli5vya7" />
        <AuthorMessage data-id="element-13" data-mp="3relvej26lm9r" />
        <Faq data-id="element-14" data-mp="6hqtghuuhen" />
        <FinalCta data-id="element-15" data-mp="6801qozk67w" />
      </main>
      <Footer data-id="element-16" data-mp="5gbgztt38r4" />
      <FloatingCta data-id="element-17" data-mp="82jf0klzq9v" />
      <PurchasePopup data-id="element-18" data-mp="2zl3cxocsjc6w" />
    </div>;
}